module.exports = __webpack_public_path__ + "assets/8ee511bd4cbdf59e8437d9dc469cb536.png";